import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT } from '../utilities/FetchHelper';

class AgeTiersService {

  getAgeTiers(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_AGE_TIERS
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    return fetchJSON(url, secureGET()).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }

  putAgeTiers(data) {
    let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_AGE_TIERS
    for (const key in data) {
      url = url.replace('{' + key + '}', data[key])
    }

    const putData = {
      hotelCode: data.hotelCode,
      ageTiers: data.ageTiers
    }

    return fetchJSON(url, { ...securePUT(), body: JSON.stringify(putData) }).then(response => {
      return response
    }).catch((error) => {
      throw error
    })
  }
}

export default new AgeTiersService();